export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SET_REFERENCE_VALUES"] = "SET_REFERENCE_VALUES";
    ActionTypes["GET_REFERENCE_VALUES"] = "GET_REFERENCE_VALUES";
})(ActionTypes || (ActionTypes = {}));
